var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgInfoicon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18.696,
    height: 18.691,
    viewBox: "0 0 18.696 18.691",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_895",
    "data-name": "Group 895",
    transform: "translate(-286.399 -272.67)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1056",
    "data-name": "Path 1056",
    d: "M305.094,282.078a9.348,9.348,0,1,1-9.3-9.407A9.386,9.386,0,0,1,305.094,282.078ZM288.116,282a7.632,7.632,0,1,0,7.725-7.618A7.626,7.626,0,0,0,288.116,282Z",
    transform: "translate(0)",
    fill: "#5c74a5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1057",
    "data-name": "Path 1057",
    d: "M374.448,365.076c.13-.6.331-1.5.519-2.4a8.6,8.6,0,0,0,.175-1.1c.042-.555-.15-.731-.7-.7-.17.01-.351.1-.418-.177s.11-.336.292-.4a6.651,6.651,0,0,1,.931-.329,1.318,1.318,0,0,1,1.712,1.542c-.133.966-.372,1.916-.557,2.875a6.4,6.4,0,0,0-.13.9c-.025.521.173.7.694.676.176-.007.391-.131.46.177s-.158.34-.34.417a5.441,5.441,0,0,1-.806.31C375.18,367.126,374.428,366.515,374.448,365.076Z",
    transform: "translate(-80.353 -80.021)",
    fill: "#5c74a5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1058",
    "data-name": "Path 1058",
    d: "M387.217,322.739a1.263,1.263,0,0,1,1.25-1.271,1.275,1.275,0,1,1-1.25,1.271Z",
    transform: "translate(-92.464 -44.755)",
    fill: "#5c74a5"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgInfoicon);
export default __webpack_public_path__ + "lbHeaderFiles/static/media/info.icon.342601349536f13ea8c6bf234f29ca5c.svg";
export { ForwardRef as ReactComponent };